// ONYX-CUSTOM: adds every product card on the page to window.gtm_product_mapping, now and when cards are inserted later.
//
// Cards carry data-onyx-gtm-product (+ merchant / old id) from snippets/onyx-tracking-ids.liquid. A missing
// id is written as undefined, with the key kept. The head snippet (onyx-gtm-product-mapping.liquid) has
// already added the product page's product and the cart, and those entries are not overwritten.

const mapping = (window.gtm_product_mapping = window.gtm_product_mapping || {});

const collect = (root) => {
  const cards = root.matches?.('[data-onyx-gtm-product]') ? [root] : [];
  cards.push(...(root.querySelectorAll?.('[data-onyx-gtm-product]') ?? []));

  cards.forEach((card) => {
    const id = card.dataset.onyxGtmProduct;
    if (id in mapping) return;
    mapping[id] = {
      merchantId: card.dataset.onyxGtmMerchantId,
      oldShopifyId: card.dataset.onyxGtmOldShopifyId,
    };
  });
};

collect(document);

// Facets and load-more replace the grid after load
new MutationObserver((records) => {
  records.forEach((record) => record.addedNodes.forEach((node) => node.nodeType === Node.ELEMENT_NODE && collect(node)));
}).observe(document.documentElement, { childList: true, subtree: true });
